import { Button } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { useModalPageContent } from '../../hooks/useTermPageContent';
import { TermModalBody } from '../TermModalBody';
import { StyledLinkAccordionBody } from './LinkAccordionBody.styles';

export function LinkAccordionBody({
  href,
  handleClose,
  closeAccordionBtnLabel,
  linkClass,
  setAccordionOpen,
}: {
  href: string;
  closeAccordionBtnLabel: string | null;
  setAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleClose: (
    setAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>
  ) => (e: React.ChangeEvent | React.MouseEvent) => void;
  linkClass: string | null;
}) {
  const state = useModalPageContent(href);

  return (
    <StyledLinkAccordionBody className="">
      <TermModalBody {...state} />
      <Button
        className={clsx('t-font-s t-display-1 term-link-accordion-button', linkClass)}
        callback={handleClose(setAccordionOpen)}
      >
        {closeAccordionBtnLabel}
      </Button>
    </StyledLinkAccordionBody>
  );
}
